var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "InventoryBox" }, [
    !_vm.data.answered
      ? _c("div", [
          _c("div", { staticClass: "SelectBox_title" }, [
            _c("strong", { staticClass: "bold" }, [
              (_vm.data.rule
              ? _vm.data.rule.isNecessary
                ? 1
                : 0
              : 0)
                ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                : _vm._e(),
              _vm._v(_vm._s(_vm.data.questionTitle))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "box" }, [
            _c(
              "div",
              { staticClass: "box_select" },
              [
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: _vm.$t("flowCertificate25") },
                    model: {
                      value: _vm.value,
                      callback: function($$v) {
                        _vm.value = $$v
                      },
                      expression: "value"
                    }
                  },
                  _vm._l(_vm.data.itemList, function(item) {
                    return _c(
                      "el-option",
                      {
                        key: item.itemNo,
                        attrs: {
                          disabled:
                            _vm.data.rule.optionCount[item.itemNo] -
                              (item.answerCount || 0) <=
                            0,
                          label: _vm.labelTxt(item.itemDes),
                          value: item.itemId
                        }
                      },
                      _vm._l(JSON.parse(item.itemDes), function(o) {
                        return _c("div", { key: JSON.stringify(o) }, [
                          _c("span", [_vm._v(_vm._s(o.txt))])
                        ])
                      }),
                      0
                    )
                  }),
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.optionCount))])
          ])
        ])
      : _c("div", [
          _c("div", { staticClass: "SelectBox_title" }, [
            _c("strong", { staticClass: "bold" }, [
              (_vm.data.rule
              ? _vm.data.rule.isNecessary
                ? 1
                : 0
              : 0)
                ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                : _vm._e(),
              _vm._v(_vm._s(_vm.data.questionTitle))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "box" }, [
            _c(
              "div",
              { staticClass: "box_select" },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      disabled: _vm.disabledBol,
                      placeholder: _vm.$t("flowCertificate25")
                    },
                    model: {
                      value: _vm.value,
                      callback: function($$v) {
                        _vm.value = $$v
                      },
                      expression: "value"
                    }
                  },
                  _vm._l(_vm.data.itemList, function(item) {
                    return _c(
                      "el-option",
                      {
                        key: item.itemNo,
                        attrs: {
                          disabled:
                            _vm.data.rule.optionCount[item.itemNo] -
                              (item.answerCount || 0) <=
                            0,
                          label: _vm.labelTxt(item.itemDes),
                          value: item.itemId
                        }
                      },
                      _vm._l(JSON.parse(item.itemDes), function(o) {
                        return _c("div", { key: JSON.stringify(o) }, [
                          _c("span", [_vm._v(_vm._s(o.txt))])
                        ])
                      }),
                      0
                    )
                  }),
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.optionCount))])
          ])
        ]),
    _vm._v(" "),
    _c("div", { staticClass: "answerObj none" }, [
      _vm._v(_vm._s(_vm.answerObj))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "isNecessary none" }, [
      _vm._v(_vm._s(_vm.data.rule ? (_vm.data.rule.isNecessary ? 1 : 0) : 0))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-49ee87b7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-49ee87b7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/module/topic/public/inventory-box.vue
// module id = null
// module chunks = 